import React from 'react';

export const MinusCircleSvg = (props) => {

  const { width, height, color } = props;

  return (
    <svg width={width ?? "20"} height={height ?? "20"} viewBox="0 0 20 20" fill={color ?? window?.settings?.primary_color ?? '#1DBD6B'} xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM14 11H6C5.4 11 5 10.6 5 10C5 9.4 5.4 9 6 9H14C14.6 9 15 9.4 15 10C15 10.6 14.6 11 14 11Z" />
    </svg>
  )
}